<button class="btn btn-outline-danger" (click)="salir()">Salir</button>